"use client";
import React from "react";
import styles from "./career-benefit.module.scss";
import BenefitSlider from "./benefit-slider";

interface CareerBenefitProps {
  data?: any;
}

const CareerBenefit = ({ data }: CareerBenefitProps) => {
  return (
    <>
      <section className="relative z-[0] overflow-hidden py-[56px] lg:py-[80px] xl:py-[100px] bg-white ">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-[calc(40%_-_15px)_calc(60%_-_15px)] 2xl:grid-cols-[calc(40%_-_15px)_calc(60%_-_15px)] gap-[30px]">
            <div
              className={`${styles.headingCareer} mb-[32px] lg:mb-[32px] xl:mb-[40px] `}
            >
              <h2 className="md:text-left text-center font-bold text-primary-text text-heading-1 mb-[12px]">
                {data?.title}
              </h2>
              <p className="md:text-left text-center text-[#32343B] text-subtitle-3">
                {data?.sort_title}
              </p>
            </div>

            <BenefitSlider data={data} />
          </div>
        </div>
      </section>
    </>
  );
};
export default CareerBenefit;
